// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gotu&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".made-by[data-v-664407dc]{font-family:\"Gotu\",sans-serif;padding:8px 0;position:absolute;left:0;bottom:0;width:100%;text-align:center;font-size:small}.made-by a[data-v-664407dc]{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
